import { ExternalLink } from "@src/appV2/lib/Links/ExternalLink";
import { Icon } from "@src/appV2/redesign/components/Icon";
import { Text } from "@src/appV2/redesign/components/Text";
import type { ReactNode } from "react";

interface AgreementLinkProps {
  to: string;
  children: ReactNode;
}

/** External link to a legal document, with the design system's "opens elsewhere" affordance. */
export function AgreementLink(props: AgreementLinkProps) {
  const { to, children } = props;

  return (
    <ExternalLink
      to={to}
      sx={(theme) => ({
        display: "inline-flex",
        alignItems: "center",
        alignSelf: "flex-start",
        gap: theme.spacing(2),
      })}
    >
      <Text inline variant="body2" semibold>
        {children}
      </Text>
      <Icon type="arrow-up-right-from-square" size="small" />
    </ExternalLink>
  );
}
